// ** React Imports
import { Suspense, lazy } from 'react'
import ReactDOM from 'react-dom'
import { PublicClientApplication } from "@azure/msal-browser"
import { MsalProvider } from "@azure/msal-react"
import { msalConfig } from "./@core/auth/authConfig"
import { clearForeignInteractionMarker } from "./@core/auth/msalInteraction"

// ** Redux Imports
import { Provider } from 'react-redux'
import axios from 'axios'

import { store } from './redux/store'

// ** Intl & ThemeColors Context
import { ToastContainer } from 'react-toastify'
import { ThemeContext } from './utility/context/ThemeColors'

// ** Spinner (Splash Screen)
import Spinner from './@core/components/spinner/Fallback-spinner'

// ** Ripple Button
import './@core/components/ripple-button'

// ** PrismJS
import 'prismjs'
import 'prismjs/themes/prism-tomorrow.css'
import 'prismjs/components/prism-jsx.min'

// ** React Perfect Scrollbar
import 'react-perfect-scrollbar/dist/css/styles.css'

// ** React Toastify
import '@styles/react/libs/toastify/toastify.scss'

// ** Core styles
import './@core/assets/fonts/feather/iconfont.css'
import './@core/scss/core.scss'
import './assets/scss/style.scss'

// ** Service Worker
import * as serviceWorker from './serviceWorker'

import addJwtInterceptor from './@core/auth/jwtInterceptor'

import LockScreen from './@core/components/lock-screen'

// ** Lazy load app
const LazyApp = lazy(() => import('./App'))

// An interaction marker left by another registration on this host (the F5
// console shares localhost with FMS; production hosts differ, so this is a
// no-op there) would make every loginRedirect throw interaction_in_progress
// for as long as the cookie lives. MSAL never cleans a marker that is not its
// own, so drop it before the instance looks at it.
clearForeignInteractionMarker(msalConfig.auth.clientId)

const msalInstance = new PublicClientApplication(msalConfig)

addJwtInterceptor(msalInstance)

// Default to using the first account if no account is active on page load
if (!msalInstance.getActiveAccount() && msalInstance.getAllAccounts().length > 0) {
  // Account selection logic is app dependent. Adjust as needed for different use cases.
  msalInstance.setActiveAccount(msalInstance.getAllAccounts()[0])
}

axios.defaults.baseURL = process.env.REACT_APP_API_BASE_URL

ReactDOM.render(
  <Provider store={store}>
    <Suspense fallback={<Spinner />}>
      <ThemeContext>
        <MsalProvider instance={msalInstance}>
          <LockScreen
              timeout={60000}>
                <LazyApp />
            </LockScreen>
        </MsalProvider>
        <ToastContainer
          newestOnTop
          position='bottom-right'
          autoClose={1000}
          hideProgressBar
          pauseOnHover={false}
          closeOnClick
        />
      </ThemeContext>
    </Suspense>
  </Provider>,
  document.getElementById('root')
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
